// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MyKUwCLG4MgzvniCY1yT{width:105px;height:32px}.YqK7GCmjWqsuMV4hxvoR{text-decoration:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createButton": `MyKUwCLG4MgzvniCY1yT`,
	"guideButton": `YqK7GCmjWqsuMV4hxvoR`
};
export default ___CSS_LOADER_EXPORT___;
